import { Controller } from '@hotwired/stimulus';

export default class OrderedCheckboxesController extends Controller {
  static targets = ['checkbox', 'badge', 'hiddenContainer']
  static values = { name: String, order: Array }

  connect() {
    if (this.orderValue.length === 0) {
      this.orderValue = this.checkboxTargets
        .filter(cb => cb.checked)
        .map(cb => cb.value)
    }
    this.#render()
  }

  toggle(event) {
    const { value } = event.params
    const newOrder = this.orderValue.filter(v => v !== value)

    if (event.currentTarget.checked) newOrder.push(value)

    this.orderValue = newOrder
    this.#render()
  }

  #render() {
    this.#updateBadges()
    this.#updateHiddenInputs()
  }

  #updateBadges() {
    this.badgeTargets.forEach(badge => {
      const index = this.orderValue.indexOf(badge.dataset.value)
      badge.textContent = index > -1 ? index + 1 : ''
      badge.classList.toggle('d-none', index === -1)
    })
  }

  #updateHiddenInputs() {
    this.hiddenContainerTarget.replaceChildren()

    this.orderValue.forEach(value => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = `${this.nameValue}[]`
      input.value = value
      this.hiddenContainerTarget.append(input)
    })
  }
}
